import {DeliveryAllPayload} from "../../../types/delivery/delivery-all-payload";
import {convertAssignmentStatusListToDeliveryStatus} from "./delivery-status-converter";
import {DeliveryAllRequest} from "../../../types/delivery/request/delivery-all-request";

export const convertPayloadToRequest = (payload: DeliveryAllPayload): DeliveryAllRequest => {
    return {
        specificDate: payload.specificDate,
        clientIds: payload.selectedClients.length > 0
            ? payload.selectedClients.map((c) => c.id).join(";")
            : undefined,
        status: convertAssignmentStatusListToDeliveryStatus(payload.selectedStatus),
    };
};
